import { defineStore } from 'pinia'
export default defineStore({
  id: 'orderDataTable',
  persist: true,
  state: () => {
    return {
      isOrderArchive: false,
      isOrderDocuementArchive: false
    }
  },
  actions: {
    setIsOrderDocumentArchive: function (payload: any) {
      this.isOrderDocuementArchive = payload
    },
    setIsOrderArchive: function (payload: any) {
      this.isOrderArchive = payload
    }
  },
  getters: {
    getIsOrderDocumentArchive: (state: any) => state.isOrderDocuementArchive,
    getIsOrderArchive: (state: any) => state.isOrderArchive
  }
})
